module.exports = __webpack_public_path__ + "img/AT0000002626412.e8efe961.png";